import React, { useEffect } from "react";
import CalendarAssorts from "../Assorts";
import useCalendarSale from "../hooks/useCalendarSale";
import "./style/style.scss";
import "./style/oneExercise.scss";
import { Exercise } from "../../../models/Exercise";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import StepIndicator from "./shared/StepIndicator";

interface IProps {
  exercise: Exercise;
  refreshCapacityAfterAddTicket: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  alertCalendar: string;
}

const CalendarOneExercise: React.FC<IProps> = ({
  exercise,
  refreshCapacityAfterAddTicket,
  joinToExerciseByPass,
  alertCalendar,
}: IProps) => {
  const { t } = useTranslation();
  const { getTicketsByExercise, tickets, ticketAccess, ticketLimit, getDetailsAboutExercise, exerciseDetails } =
    useCalendarSale();

  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup, exercise);
    getDetailsAboutExercise(exercise.objectId);
    //eslint-disable-next-line
  }, []);

  const isDesktop = useMediaQuery("(min-width: 1100px)");

  return (
    <>
      {isDesktop ? (
        <div className="calendar-modal-one-exercise box shadow border">
          <CalendarAssorts
            alertCalendar={alertCalendar}
            exerciseDetails={exerciseDetails}
            joinToExerciseByPass={joinToExerciseByPass}
            tickets={tickets}
            ticketAccess={ticketAccess}
            ticketLimit={ticketLimit}
            refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
          />
        </div>
      ) : (
        <div className="">
          <div className="calendar-modal-steps">
            <StepIndicator number={2} label={t("wybierz_rodzaj_i_ilosc_biletow")} />
          </div>

          <CalendarAssorts
            alertCalendar={alertCalendar}
            exerciseDetails={exerciseDetails}
            joinToExerciseByPass={joinToExerciseByPass}
            tickets={tickets}
            ticketAccess={ticketAccess}
            ticketLimit={ticketLimit}
            refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
          />
        </div>
      )}
    </>
  );
};

export default CalendarOneExercise;
